
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderProductBillingItemsDialog extends Serenity.EntityDialog<OrderProductBillingItemsRow, any> {
        protected getFormKey() { return OrderProductBillingItemsForm.formKey; }
        protected getIdProperty() { return OrderProductBillingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return OrderProductBillingItemsRow.localTextPrefix; }
        protected getService() { return OrderProductBillingItemsService.baseUrl; }
        protected getDeletePermission() { return OrderProductBillingItemsRow.deletePermission; }
        protected getInsertPermission() { return OrderProductBillingItemsRow.insertPermission; }
        protected getUpdatePermission() { return OrderProductBillingItemsRow.updatePermission; }

        protected form = new OrderProductBillingItemsForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            return buttons;
        }
    }
}